import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { momentObj } from 'react-moment-proptypes';
import styled from 'styled-components';
import { SectionContainer } from './styles';

const Container = styled(SectionContainer)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 170px;
  margin-bottom: -142px;
  z-index: 1;
`;

const GenDate = styled.span`
  margin-top: 5px;
  font: ${props => props.theme.fontWeightBold} 14px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
`;

const Button = styled.button`
  height: 28px;
  font: 800 14px/120% ${props => props.theme.fontFamilyBody};
  margin-left: 15px;
  text-transform: uppercase;
  background-color: transparent;
  outline: none;
`;

const RefreshButton = styled(Button)`
  width: 78px;
  border: none;
  color: ${props => props.theme.primaryColor};
`;

export default function Actions({ generatedAt, onRefreshClick }) {
  const [updatedAt, setUpdatedAt] = React.useState(null);

  React.useEffect(() => {
    setUpdatedAt(moment(generatedAt).fromNow());
    const interval = setInterval(() => {
      setUpdatedAt(moment(generatedAt).fromNow());
    }, 5000);
    return () => clearInterval(interval);
  }, [generatedAt]);

  const handleRefresh = e => {
    e.preventDefault();
    onRefreshClick();
  };

  return (
    <Container>
      <GenDate>
        {updatedAt && `Updated ${updatedAt}`}
      </GenDate>
      <RefreshButton type="button" onClick={handleRefresh}>Refresh</RefreshButton>
    </Container>
  );
}

Actions.propTypes = {
  generatedAt: momentObj.isRequired,
  onRefreshClick: PropTypes.func.isRequired,
};
